module.exports = __webpack_public_path__ + "static/img/grok.1649eede.webp";